import { Component, OnDestroy, OnInit } from '@angular/core';
import { IFaq } from '@shared/interfaces';
import { AdminService } from '../../admin.service';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { DialogService } from '@shared/services';
import { AdminFaqService } from '@app/main/admin/modules/admin-faq/services/admin-faq.service';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-faq',
    templateUrl: './admin-faq.component.html',
    styleUrls: ['./admin-faq.component.scss'],
    standalone: false
})
export class AdminFaqComponent extends AdminActionsDirective implements OnInit, OnDestroy {
    constructor(
        private adminFaqService: AdminFaqService,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
    }

    get dataArray(): IFaq[] {
        return this.data as IFaq[];
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.adminFaqService.historyStack = [];
    }
}
